"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
/**
 * Placeholder component for any view
 */
function PlaceholderView() {
    return React.createElement("div", null);
}
exports.default = react_redux_1.connect(function (state) { return state; })(PlaceholderView);
